/**
 * RestQL projection for every referring-physician picker / dropdown (ENG-2221). Without a `query`
 * the list endpoint returns every serializer field for up to 300 rows (~160KB). These are the
 * fields the pickers and their form consumers read: the label (`full_name` and the name parts
 * `formatPhysician` falls back on), the contact details the patient profile shows for a selected
 * physician (`email`, `phone`, `fax_phone`, `npi`), `email` for the email recipients list, and the
 * practice name and address the fax form prints on its cover page (`physician-cover-page-details.util`).
 *
 * Never add `referred_count`: the list endpoint only runs its 4-way UNION annotation when a
 * `query` names that field (ENG-1186). It belongs to /settings/physicians alone.
 */
export const PHYSICIAN_PICKER_QUERY =
  "{id,first_name,middle_name,last_name,full_name,title,suffix,npi,practice_name,email,phone,fax_phone,street_address_1,street_address_2,city,state,zip_code}";

// SN-19728. Only with the review-queue flag on: a backend that predates `intake_review_pending` 400s
// the whole list on an unknown field. See `usePhysicianPickerQuery`.
export const PHYSICIAN_PICKER_QUERY_WITH_REVIEW =
  PHYSICIAN_PICKER_QUERY.replace("}", ",intake_review_pending}");
